import { GridColumnSettings } from '@/shared/types/grid';

export const booleanColumn = <T>(options: {
  uid?: string;
  field: keyof T & string;
  header: string;
  iconClass?: string;
  allowFiltering?: boolean;
  allowSorting?: boolean;
  visible?: boolean;
}): GridColumnSettings<T> => {
  const { uid, field, header, iconClass, allowFiltering, allowSorting, visible } = options ?? {};

  return {
    uid: uid ?? field,
    field,
    headerText: header,
    headerTemplate: iconClass ? `<i class="${iconClass} text-more-muted" title="${header}"></i>` : undefined,
    type: 'boolean',
    headerTextAlign: 'Center',
    textAlign: 'Center',
    template: `\${if(${field})}<i class="fa-solid fa-circle-check text-primary"></i>\${/if}`,
    allowFiltering: allowFiltering ?? true,
    allowSorting: allowSorting ?? true,
    width: 100,
    visible: visible ?? true,
    extra: {
      filter: {
        options: [
          { text: 'True', value: true },
          { text: 'False', value: false },
        ],
      },
    },
  };
};
